export default __webpack_public_path__ + "static/media/menu.ccfb0d17.svg";